export default theme => ({
  root: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  component: {
    display: "table-cell",
  },
  input: {
    padding: "15px 12px 10px",
  },
  button: {
    borderColor: theme.palette.white.main,
    background: theme.palette.white.main,
    borderStyle: "hidden",
  },
});
